import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ServiceBase } from '../../../shared/service-base/ServiceBase';

@Injectable({
  providedIn: 'root'
})
export class OnePageService extends ServiceBase {

  private baseUrlService: string;
  url: string;

  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return this.url;
  }

  public buscarDados(filtros: any): Promise<any> {
    this.url = `${this.baseUrlService}/one-page`;

    return this.getComQueryParams({
      data_inicial: filtros.dataInicial,
      data_final: filtros.dataFinal,
      dealers: filtros.dealers,
    });
  }
}
